//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';

    angular.module('container.widgets')
        .directive('srsngAdvancedSearch', advancedSearch);

    function advancedSearch() {
        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/advanced-search/advanced-search.html',
            scope: {
                options: '=',
                actionCallback: '&',
                actionCallbackReset: '&'
            },
            transclude: true,
            controller: controller


        };

        function controller(
            $scope,
            $rootScope,
            $window,
            authenticationService,
            localStorageService) {

            $scope.openPopup = false;
            $scope.showColumnBar = true;
            $scope.filter = {};
            var previousStateImage = '';
            $scope.openPopupImage = false;
            $scope.openNav = openNav;                   
            $scope.closeNav = closeNav;                 
            $scope.search = search;
            $scope.isOpen = true;
            $scope.currentStatus = false;
            let storageKey = $scope.options.tableId + '_' + authenticationService.profile.username;
            let storedData  = localStorageService.get(storageKey);
            let searchedInfo = {};
            let startDestroy;

            init();
            /**
             * @name init
             * @description to invoke the callback function when advanced search is applied and advanced search keys
             * and values are stored in localstorage
             */
            function init() {
                if (!_.isEmpty(storedData)) {
                    
                    Object.keys(storedData).forEach(item => $scope.filter[item] = storedData[item]);
                    $scope.actionCallback({ param: $scope.filter });
                }
            }
            function openNav() {                        
                $scope.isOpen = true;
            }
            function closeNav() {                     
                $scope.isOpen = false;
            }

            /**
             * @description will be called when user clicks on search button
             * @name search
             */
            function search () {
                searchedInfo = _.cloneDeep($scope.filter);
                $scope.actionCallback({ param: $scope.filter });
            }

            $scope.showColumns = function (column) {
                $scope.showColumnBar = !column;
            };


            $scope.columnName = $scope.options.model.columns;

            $scope.openList = function (id) {
                if (previousStateImage != '') {                             
                    $scope.currentStatus = false;
                    $scope.rotator = document.getElementById("targetAction" + previousStateImage);      
                    $scope.rotator.src = "container/ui/assets/img/icons/system-icons-16x16/system-ic-arrow-drop-up-16x16.svg";
                }
                $scope.openPopupImage = true;                                  
                if (!$scope.currentStatus) {                                        
                    $scope.targetInfo = 'targetAction' + id;
                    $scope.actualIndex = id;
                    previousStateImage = id;
                    $scope.currentStatus = true;
                    $scope.rotator = document.getElementById("targetAction" + id);
                    $scope.rotator.src = "container/ui/assets/img/icons/system-icons-16x16/system-ic-arrow-drop-right-blue-16x16.svg";
                }
            };

            $scope.closePopup = function (id) {
                $scope.openPopup = false;
                $scope.currentStatus = false;
                $scope.openPopupImage = false;
                $scope.rotator = document.getElementById("targetAction" + $scope.actualIndex);        
                $scope.rotator.src = "container/ui/assets/img/icons/system-icons-16x16/system-ic-arrow-drop-up-16x16.svg";
            };

            $scope.onEnterKeyPress = function (event, data) {                   
                if (event.charCode === 13) {
                    searchedInfo = data;
                    $scope.actionCallback({ param: data });
                }
            };

            $scope.closeList = function (keys, data, indexing) {
                var index;
                for (let keyLength = 0; keyLength < $scope.columnName.length; keyLength++) {
                    if ($scope.columnName[keyLength].key === keys) {
                        index = keyLength;
                    }
                }
                let popupColumn = $scope.columnName[$scope.actualIndex];
                $scope.columnName[index].key = popupColumn.key;
                $scope.columnName[index].title = popupColumn.title;
                $scope.columnName[$scope.actualIndex].key = keys;
                $scope.columnName[$scope.actualIndex].title = data;
                if (index > 9) {
                    delete $scope.filter[$scope.columnName[index].key];
                }
                $scope.closePopup($scope.actualIndex); 
                $scope.openPopup = false;              
            };

            $scope.reset = function () {                                
                $scope.filter = {};
                searchedInfo = {};
                let storageKey = $scope.options.tableId + '_' + authenticationService.profile.username;
                localStorageService.set(storageKey, {});
                $scope.actionCallbackReset({ param: $scope.filter });
            };


            $scope.$watch('openPopupImage', function (newVal) {
                $scope.currentStatus = false;
                if (!newVal) {
                    if ($scope.rotator !== undefined) {
                        $scope.rotator = document.getElementById("targetAction" + previousStateImage);      
                        $scope.rotator.src = "container/ui/assets/img/icons/system-icons-16x16/system-ic-arrow-drop-up-16x16.svg";
                    }
                }
            });

            startDestroy = $rootScope.$on('$stateChangeStart', storeSearchedInfo);

            $window.addEventListener('beforeunload', storeSearchedInfo);

            /**
             * @name storeSearchedInfo
             * @description To store the advanced search keys and values in localstorage specific for table and user when browser refreshed
             * or state is changed
             */
            function storeSearchedInfo() {
                let storageKey = $scope.options.tableId + '_' + authenticationService.profile.username;
                if (!_.isEmpty(searchedInfo)) {
                    localStorageService.set(storageKey, searchedInfo);
                }
            }

            /**
             * @description To deregister the state change event once advanced search component destroyed
             */
            $scope.$on('$destroy', function () {
                startDestroy();
            });

        }
    }

})();
